import { render } from "./InterfaceMainMenu.vue?vue&type=template&id=eb73ab06&scoped=true"
import script from "./InterfaceMainMenu.vue?vue&type=script&lang=js"
export * from "./InterfaceMainMenu.vue?vue&type=script&lang=js"

import "./InterfaceMainMenu.vue?vue&type=style&index=0&id=eb73ab06&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb73ab06"]])

export default __exports__